require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-using-view-composers-laravel-5-2.json") })
        }
      }, "path---post-using-view-composers-laravel-5-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-using-view-composers-laravel-5-2!./.cache/json/post-using-view-composers-laravel-5-2.json
// module id = 364
// module chunks = 231608221292675